import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, message, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useGetTransportationTypeByFactory } from "hooks/useFactory";
import MainCreateTransportation from "./MainCreateTransportation";
import { useCreateMasterTransport } from "hooks/useMasterData";
import dayjs from "dayjs";
import CreateTransportationFooter from "./CreateTransportationFooter";
import { useAppSelector } from "store";
import { useState } from "react";
import { ParkinglistInput } from "@/services/interface";
import { useQueryClient } from "@tanstack/react-query";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};
const CreateTransportation = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: dataTransportation } = useGetTransportationTypeByFactory(
    factoryId ?? ""
  );
  const { mutate: CreateTransportation, isPending: crateLoading } =
    useCreateMasterTransport();

  const [parkingListInput, setParkingListInput] = useState<ParkinglistInput[]>(
    []
  );

  const queryClient = useQueryClient();

  const onFinish = (values: any) => {
    // console.log(values);
    CreateTransportation(
      {
        name: values.transport_name,
        province_start_id: values.province_start_id,
        district_start_id: values.district_start_id,
        province_end_id: values.province_end_id,
        district_end_id: values.district_end_id,
        time_end: dayjs(values?.timeEnd).format("HH:mm") || "",
        time_start: dayjs(values?.timeStart).format("HH:mm") || "",
        type: values.type,
        service_price: 100,
        parking_list: parkingListInput,
        description: "",
      },
      {
        onSuccess: async (data) => {
          await queryClient.refetchQueries({
            queryKey: ["parkingTransportProvinceType"],
            type: "all",
          });
          message.success("เพิ่มข้อมูลขนส่งสำเร็จ");
          navigate("/manage-transportation/update/" + data.data.id);
        },
        onError: (error) => {
          message.error("เพิ่มข้อมูลขนส่งไม่สำเร็จ");
          console.log(error);
        },
      }
    );
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      onFinish={onFinish}
      labelAlign="left"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 12 }}
    >
      <Row className="rowgap-vbox" gutter={[24, 0]} style={{ height: "100%" }}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/manage-transportation");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>เพิ่มขนส่ง</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <MainCreateTransportation
                dataType={dataTransportation?.data}
                form={form}
                parkingListInput={parkingListInput}
                setParkingListInput={setParkingListInput}
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <CreateTransportationFooter />
    </Form>
  );
};

export default CreateTransportation;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
// height: 500px;
